import { appInsightsLogger } from "core/monitoring/AppInsights";
import { onLogout } from "core/javascriptChannels";
import { UseAuthResult } from "core/auth/model";
import { WhatsNewState } from "core/state/whatsNewState";
import { ClientInfoState } from "shared/core/state/clientInfoState";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

export const handleLogout = (auth: UseAuthResult) => {
  appInsightsLogger.info("useAuth - useLogout.ts");
  return () => {
    if (auth.isAuthenticated) {
      trackEvents(EventNames.LOGOUT);
      WhatsNewState.clear();
      ClientInfoState.clear();
      auth.signoutRedirect();
      onLogout();
    }
  };
};
